webpackJsonp([36405802532802],{

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookActions = __webpack_require__(26);
	
	var _LoreHookActions2 = _interopRequireDefault(_LoreHookActions);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookActions2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'blueprints'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Blueprints are used to provide models with a default set of actions for interacting with a REST API. If you want to modify the behavior of those actions you can provide your own implementation here.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      blueprints: {\n        create: function() { /*...*/ },\n        destroy: function() { /*...*/ },\n        find: function() { /*...*/ },\n        get: function() { /*...*/ },\n        update: function() { /*...*/ }\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-actions-options-blueprints-js-865ba3c1d179fa07b891.js